module.exports = __webpack_public_path__ + "media/images/SSO_Clever-6150eea8.svg";